module.exports = __webpack_public_path__ + "images/application/illustrations/infrastructure-5bea59be.svg";